import api from '@/logic/api'

export default {
  getTmpLoginToken: () => api.get('/tmp-login-token'),
  loginViaTmpToken: (token) => api.post('/tmp-login-token', {
    token,
  }),
}
